import React, { useEffect } from 'react';
import dayjs from 'dayjs';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { initialState as pendingProjectInitialState } from '~redux/slices/approval';

import SearchAndFilterBar, { TSearchAndFilterBarProps } from '~components/molecules/SearchAndFilterBar';

import * as Styles from './_projectApprovalTableSearchAndFilterBar.module.scss';
import { ProjectChangeHistoryStatusEnum } from '~utils/enums';
import { TPendingProjectApprovalListingFilters } from '~types/feat/approval';

const ProjectApprovalSearchAndFilterBar = () => {
    const filters = useAppSelector(state => state.approval.pendingProjectListing.filters);
    const initialFilters = pendingProjectInitialState.pendingProjectListing.filters;

    const dispatch = useAppDispatch();

    const setFilters = (inputFilters: TPendingProjectApprovalListingFilters) => dispatch(combinedActions.approvalSetPendingProjectListingFilters(inputFilters));
    const handleSearchClick = () => dispatch(combinedActions.approvalGetPendingProjectListingAttempt());

    useEffect(() => {
        setFilters({
            ...filters,
        });
    }, []);

    const handleCancelClick = () => {
        setFilters({
            ...initialFilters,
        });
        dispatch(combinedActions.approvalGetPendingProjectListingAttempt());
    };

    const fields: TSearchAndFilterBarProps['fields'] = [
        {
            label: 'Project Name:',
            type: 'input' as const,
            inputParams: {
                value: filters.projectName,
                setValue: (event) => setFilters({ ...filters, projectName: event.target.value }),
                onKeyDown: (event) => { if (event.key === 'Enter') handleSearchClick(); },
                className: Styles.input,
            },
        },
        {
            label: 'Date From:',
            type: 'datepicker' as const,
            datepickerParams: {
                date: filters.dateFrom,
                setDate: (date: string) => {
                    if (date > filters?.dateTo) {
                        setFilters({ ...filters, dateFrom: date, dateTo: '' });
                    } else setFilters({ ...filters, dateFrom: date });
                },
                maxDate: dayjs().toISOString(),
                startDate: filters.dateFrom,
                endDate: filters.dateTo,
                selectsStart: true,
            },
        },
        {
            label: 'Date To:',
            type: 'datepicker' as const,
            datepickerParams: {
                date: filters.dateTo,
                minDate: filters.dateFrom,
                setDate: (date: string) => setFilters({ ...filters, dateTo: date }),
                startDate: filters.dateFrom,
                endDate: filters.dateTo,
                selectsEnd: true,
            },
        },
    ];

    return (
        <SearchAndFilterBar
            fields={fields}
            searchOnClick={handleSearchClick}
            cancelOnClick={handleCancelClick}
            containerClassName={Styles['content-container']}
            gridColumns={2}
        />
    );
};

export default ProjectApprovalSearchAndFilterBar;
